<template>
    <span>
        <img :src="image" class="mr-1" style="max-width: 14px;">
        <span :class="availabilityColorsMap[warehouseAvailability]">
            {{ availabilityMapStore[warehouseAvailability] }}
        </span>
    </span>
</template>

<script>
    import { mapState } from 'vuex';

    const IMG_DIR = '/themes/realgeek/img/';

    export default {
        name: 'availability',
        props: ['product'],
        data () {
            return {
                availabilityColorsMap: {
                    0: 'color-red',
                    1: 'color-yellow',
                    2: 'color-yellow',
                    3: 'color-yellow',
                    4: 'color-green',
                    5: 'color-yellow',
                },
                availabilityMapStore: {
                    0: 'Není skladem',
                    1: 'Na cestě na e-shop',
                    2: 'Předobjednávka',
                    3: 'Skladem e-shop', /* méně než 5ks */
                    4: 'Skladem e-shop', /* skladem */
                    5: 'Skladem e-shop', /* posledních 5 ks */
                }
            }
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            warehouseAvailability: function () {
                if (!this.product) {
                    return;
                }
                return this.product.availability[this.product.id_attribute].warehouse;
            },
            image: function () {
                switch (this.warehouseAvailability) {
                    case 0:
                        return IMG_DIR + 'cross-red.png';
                    case 1:
                    case 2:
                    case 3:
                    case 5:
                    case 6:
                        return IMG_DIR + 'check-yellow.svg';
                    case 4:
                        return IMG_DIR + 'check-green.png';
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    span {
        font-size: 16px;
        font-weight: 700;

        @media (max-width: 1349px) {
            font-size: 14px;
        }

        &.color-green {
            color: #6eb540;
        }

        &.color-red {
            color: #d92628;
        }

        &.color-yellow {
            color: #f2b705;
        }
    }
</style>
